import { Routes, Route, Link, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { RedeemCode } from './pages/RedeemCode';
import { TakeAttempt } from './pages/TakeAttempt';
import { Results } from './pages/Results';
import { CandidateDashboard } from './pages/CandidateDashboard';
import { Health } from './pages/Health';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminCandidate } from './pages/AdminCandidate';
import { AuthProvider } from './lib/auth';
import { Brand } from './components/Brand';

export function App() {
  return (
    <AuthProvider>
      <div className="app-shell">
        <header className="app-header">
          <Link to="/" className="brand-link">
            <Brand />
          </Link>
          <nav className="header-nav">
            <Link to="/take">Take a test</Link>
            <Link to="/admin">Admin</Link>
          </nav>
        </header>
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/take" element={<RedeemCode />} />
            <Route path="/take/:code" element={<RedeemCode />} />
            <Route path="/attempt/:id" element={<TakeAttempt />} />
            <Route path="/results/:id" element={<Results />} />
            <Route path="/me" element={<CandidateDashboard />} />
            <Route path="/health" element={<Health />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/candidates/:id" element={<AdminCandidate />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <footer className="app-footer">
          <span>© Integrella · Benchmark & Technical Dojo</span>
        </footer>
      </div>
    </AuthProvider>
  );
}
